// extracted by mini-css-extract-plugin
module.exports = {"wpp-float-button":"WppFloatButton_wpp-float-button__QaZkf"};